import { render, staticRenderFns } from "./SystemCallNumGroupPage.vue?vue&type=template&id=ded008ea&scoped=true&"
import script from "./SystemCallNumGroupPage.vue?vue&type=script&lang=js&"
export * from "./SystemCallNumGroupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded008ea",
  null
  
)

export default component.exports